import { motion } from "framer-motion";

const partners = [
  {
    name: "Google",
    logo: "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a9e0276ca6e04d2301f73d3.svg",
    className: "h-9 w-auto",
  },
  {
    name: "Meta",
    logo: "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a9e0278b81a3502a88f15b8.svg",
    className: "h-8 w-auto",
  },
  {
    name: "WhatsApp",
    logo: "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a9e0277b81a3502a88f15ae.svg",
    className: "h-9 w-auto",
  },
  {
    name: "Instagram",
    logo: "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a9e0278b81a3502a88f15b8.svg",
    className: "h-8 w-auto",
  },
];

export const PartnersSection = () => {
  return (
    <section className="bg-[#08080A] py-16 lg:py-20 relative border-t border-white/5">
      <div className="container mx-auto px-6 max-w-[1200px]">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="text-center text-[#71717A] font-mono text-[12px] tracking-[0.08em] uppercase mb-8"
        >
          ● SE INTEGRA CON LAS HERRAMIENTAS QUE YA USÁS
        </motion.p>

        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 lg:gap-x-16">
          {partners.map((partner, index) => (
            <motion.div
              key={partner.name}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{
                duration: 0.5,
                delay: index * 0.06,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="flex items-center gap-2.5 opacity-70 hover:opacity-100 transition-opacity duration-300"
              title={partner.name}
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className={`${partner.className} max-h-8 object-contain grayscale brightness-200`}
              />
              <span className="text-white/70 text-[15px] font-medium tracking-tight whitespace-nowrap">
                {partner.name}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
